export const createActionTypes = (
  action,
  success = `${action}_SUCCESS`,
  failed = `${action}_FAILED`,
  canceled = `${action}_CANCELED`,
  polling = `${action}_POLLING`,
) => {
  return {
    action,
    polling,
    success,
    failed,
    canceled,
  }
}

// export const getFullActionName = (action) => `Uber/${action}`
